import { IconButton } from "@mui/material";
import { API } from "aws-amplify";
import AddIcon from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";

export default function RecipePreview({
  recipe,
  onClick,
  addRecipe,
  disabled = false,
}) {
  const [hover, setHover] = useState(false);
  const buttonRef = useRef();
  const handleClick = (e) => {
    if (e.currentTarget != e.target || disabled) return;
    onClick();
  };
  return (
    <div
      style={{
        backgroundColor: "#eee",
        width: "175px",
        height: "200px",
        padding: "10px",
        margin: "10px",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        boxShadow: "#888 -6px 6px 4px ",
        cursor: disabled ? "auto" : "pointer",
        borderRadius: "5px",
        position: "relative",
      }}
      onClick={handleClick}
      onMouseEnter={() => setHover(!disabled)}
      onMouseLeave={() => setHover(false)}
    >
      {hover && (
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#0004",
            position: "absolute",
            borderRadius: "5px",
            top: 0,
          }}
          onClick={handleClick}
        />
      )}
      {hover && (
        <div
          style={{
            position: "absolute",
            top: 10,
            right: 10,
          }}
          ref={buttonRef}
        >
          <IconButton style={{ backgroundColor: "white" }} onClick={addRecipe}>
            <AddIcon />
          </IconButton>
        </div>
      )}

      <img
        style={{ objectFit: "cover", width: "160px", height: "150px" }}
        height={150}
        src={recipe.image}
      />

      <div
        style={{
          textAlign: "center",
          fontSize: 18,
          fontWeight: "600",
          paddingTop: "5px",
        }}
      >
        {recipe.name}
      </div>
      {/* <div>{recipe.totalTime}</div> */}
    </div>
  );
}
